import { render, staticRenderFns } from "./InspectionLayout.vue?vue&type=template&id=06a70a6e&"
import script from "./InspectionLayout.vue?vue&type=script&lang=js&"
export * from "./InspectionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports